/* MT blog sections (blog template) */
  function normalizeBlogTag(value) {
    return (value || '').trim().toLowerCase();
  }

  function buildBlogPageItems(current, total) {
    if (total <= 1) return [1];

    var delta = 1;
    var maxVisible = delta * 2 + 1;

    if (total <= maxVisible + 2) {
      var all = [];
      for (var i = 1; i <= total; i += 1) all.push(i);
      return all;
    }

    var items = [];
    var start = current - delta;
    var end = current + delta;

    if (current <= delta + 1) {
      start = 1;
      end = Math.min(total, maxVisible);
      for (var p = start; p <= end; p += 1) items.push(p);
      if (end < total - 1) {
        items.push('ellipsis');
        items.push(total);
      } else if (end < total) {
        items.push(total);
      }
      return items;
    }

    if (current >= total - delta) {
      start = Math.max(1, total - maxVisible + 1);
      if (start > 2) {
        items.push(1);
        items.push('ellipsis');
      } else if (start > 1) {
        items.push(1);
      }
      for (var q = start; q <= total; q += 1) items.push(q);
      return items;
    }

    for (var n = start; n <= end; n += 1) {
      items.push(n);
    }
    items.push('ellipsis');
    items.push(total);
    return items;
  }

  if (!customElements.get('mt-blog-filter')) {
    customElements.define('mt-blog-filter', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        this.perPage = parseInt(this.dataset.perPage, 10) || 4;
        this.grid = this.querySelector('[data-mt-blog-grid]');
        this.emptyEl = this.querySelector('[data-mt-blog-empty]');
        this.pagination = this.querySelector('[data-mt-blog-pagination]');
        this.pagePrev = this.querySelector('[data-mt-page-prev]');
        this.pageNext = this.querySelector('[data-mt-page-next]');
        this.pageList = this.querySelector('[data-mt-page-list]');
        this.filterButtons = this.querySelectorAll('[data-mt-filter-btn]');
        this.cards = Array.from(this.querySelectorAll('[data-blog-card]'));

        this.initDrawer();
        this.initShareButtons();

        if (!this.grid || !this.cards.length) return;

        this.state = {
          filterTag: '',
          currentPage: 1,
          visibleCards: this.cards.slice()
        };

        this.filterButtons.forEach((btn) => {
          btn.addEventListener('click', () => {
            this.applyFilter(normalizeBlogTag(btn.getAttribute('data-filter')));
          });
        });

        if (this.pagePrev) {
          this.pagePrev.addEventListener('click', () => {
            if (this.state.currentPage > 1) {
              this.goToPage(this.state.currentPage - 1);
            }
          });
        }

        if (this.pageNext) {
          this.pageNext.addEventListener('click', () => {
            if (this.state.currentPage < this.getTotalPages()) {
              this.goToPage(this.state.currentPage + 1);
            }
          });
        }

        var urlParams = new URLSearchParams(window.location.search);
        var urlTag = normalizeBlogTag(urlParams.get('tag'));
        var dataTag = normalizeBlogTag(this.dataset.initialTag);
        var initialTag = urlTag || dataTag;
        var initialPage = parseInt(urlParams.get('page'), 10) || 1;
        var hasMatchingButton = false;

        this.filterButtons.forEach((btn) => {
          if (normalizeBlogTag(btn.getAttribute('data-filter')) === initialTag) {
            hasMatchingButton = true;
          }
        });

        if (initialTag && !hasMatchingButton) {
          initialTag = '';
        }

        this.applyFilter(initialTag, { page: initialPage, updateUrl: false });
      }

      disconnectedCallback() {
        this.closeDrawer();
        if (this._onKeydown) {
          document.removeEventListener('keydown', this._onKeydown);
        }
        if (this._mobileQuery && this._onMqChange) {
          if (this._mobileQuery.removeEventListener) {
            this._mobileQuery.removeEventListener('change', this._onMqChange);
          } else {
            this._mobileQuery.removeListener(this._onMqChange);
          }
        }
      }

      getTotalPages() {
        return Math.max(1, Math.ceil(this.state.visibleCards.length / this.perPage));
      }

      cardMatches(card, filterTag) {
        if (!filterTag) return true;
        var tags = (card.getAttribute('data-tags') || '').split('|').filter(Boolean);
        return tags.indexOf(filterTag) !== -1;
      }

      setActiveFilterButton(filterTag) {
        this.filterButtons.forEach((btn) => {
          var btnTag = normalizeBlogTag(btn.getAttribute('data-filter'));
          var isActive = btnTag === filterTag;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-current', isActive ? 'true' : 'false');
        });
      }

      syncUrl(filterTag) {
        var url = new URL(window.location.href);
        if (filterTag) {
          url.searchParams.set('tag', filterTag);
        } else {
          url.searchParams.delete('tag');
        }
        if (this.state.currentPage > 1) {
          url.searchParams.set('page', String(this.state.currentPage));
        } else {
          url.searchParams.delete('page');
        }
        window.history.replaceState({}, '', url);
      }

      goToPage(page, options) {
        options = options || {};
        var totalPages = this.getTotalPages();
        this.state.currentPage = Math.min(Math.max(1, page), totalPages);
        this.renderPage();
        if (options.updateUrl !== false) {
          this.syncUrl(this.state.filterTag);
        }
        if (options.scroll !== false && this.grid) {
          this.grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }

      renderPaginationControls() {
        if (!this.pagination || !this.pageList) return;

        var totalPages = this.getTotalPages();

        if (this.state.currentPage > totalPages) {
          this.state.currentPage = totalPages;
        }

        var showPagination = totalPages > 1;
        this.pagination.hidden = !showPagination;

        if (!showPagination) {
          this.pageList.innerHTML = '';
          return;
        }

        if (this.pagePrev) {
          this.pagePrev.disabled = this.state.currentPage <= 1;
        }
        if (this.pageNext) {
          this.pageNext.disabled = this.state.currentPage >= totalPages;
        }

        var items = buildBlogPageItems(this.state.currentPage, totalPages);
        this.pageList.innerHTML = '';

        items.forEach((item) => {
          if (item === 'ellipsis') {
            var ellipsis = document.createElement('span');
            ellipsis.className = 'mt-blog-filter__page-ellipsis';
            ellipsis.textContent = '...';
            ellipsis.setAttribute('aria-hidden', 'true');
            this.pageList.appendChild(ellipsis);
            return;
          }

          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'mt-blog-filter__page-num';
          btn.textContent = String(item);
          btn.setAttribute('data-page', String(item));
          btn.setAttribute('aria-label', 'Page ' + item);

          if (item === this.state.currentPage) {
            btn.classList.add('is-active');
            btn.setAttribute('aria-current', 'page');
          }

          btn.addEventListener('click', () => {
            this.goToPage(item);
          });

          this.pageList.appendChild(btn);
        });

        var activeBtn = this.pageList.querySelector('.mt-blog-filter__page-num.is-active');
        if (activeBtn && typeof activeBtn.scrollIntoView === 'function') {
          activeBtn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
      }

      renderPage() {
        var total = this.state.visibleCards.length;
        var start = (this.state.currentPage - 1) * this.perPage;
        var end = start + this.perPage;

        this.cards.forEach((card) => {
          card.hidden = true;
        });

        if (total === 0) {
          if (this.emptyEl) this.emptyEl.hidden = false;
          if (this.pagination) this.pagination.hidden = true;
          return;
        }

        if (this.emptyEl) this.emptyEl.hidden = true;

        this.state.visibleCards.forEach((card, index) => {
          card.hidden = index < start || index >= end;
        });

        this.renderPaginationControls();
      }

      applyFilter(filterTag, options) {
        options = options || {};
        this.state.filterTag = filterTag;
        this.state.currentPage = options.page || 1;
        this.state.visibleCards = this.cards.filter((card) => {
          return this.cardMatches(card, filterTag);
        });

        this.setActiveFilterButton(filterTag);
        this.renderPage();
        if (options.updateUrl !== false) {
          this.syncUrl(filterTag);
        }
      }

      initDrawer() {
        this.toggle = this.querySelector('[data-mt-blog-filter-toggle]');
        this.drawer = this.querySelector('[data-mt-blog-filter-drawer]');
        this.closeTriggers = this.querySelectorAll('[data-mt-blog-filter-close]');
        this._mobileQuery = window.matchMedia('(max-width: 989px)');

        if (!this.toggle || !this.drawer) return;

        this.toggle.addEventListener('click', () => {
          if (!this._mobileQuery.matches) return;
          this.openDrawer();
        });

        this.closeTriggers.forEach((btn) => {
          btn.addEventListener('click', () => {
            this.closeDrawer();
          });
        });

        this.filterButtons.forEach((btn) => {
          btn.addEventListener('click', () => {
            if (this._mobileQuery.matches) {
              this.closeDrawer();
            }
          });
        });

        this._onKeydown = (event) => {
          if (event.key === 'Escape' && this.drawer.classList.contains('is-open')) {
            this.closeDrawer();
          }
        };
        document.addEventListener('keydown', this._onKeydown);

        this._onMqChange = () => {
          if (!this._mobileQuery.matches) {
            this.closeDrawer();
          }
        };

        if (this._mobileQuery.addEventListener) {
          this._mobileQuery.addEventListener('change', this._onMqChange);
        } else {
          this._mobileQuery.addListener(this._onMqChange);
        }
      }

      openDrawer() {
        if (!this.drawer || !this.toggle) return;
        this.drawer.classList.add('is-open');
        document.body.classList.add('mt-blog-filter-drawer-open');
        this.toggle.setAttribute('aria-expanded', 'true');
      }

      closeDrawer() {
        if (!this.drawer || !this.toggle) return;
        this.drawer.classList.remove('is-open');
        document.body.classList.remove('mt-blog-filter-drawer-open');
        this.toggle.setAttribute('aria-expanded', 'false');
      }

      initShareButtons() {
        this.querySelectorAll('[data-share-url]').forEach((btn) => {
          btn.addEventListener('click', () => {
            var url = btn.getAttribute('data-share-url');
            if (!url) return;
            if (navigator.share) {
              navigator.share({ url: url, title: document.title }).catch(function () {});
            } else if (navigator.clipboard) {
              navigator.clipboard.writeText(url).catch(function () {});
            }
          });
        });
      }
    });
  }
